(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-product-recommendations"]) return;
  try {
    
   function recommendations_loaded() {
      const recommendations_swiper = new Swiper(".product-recommendations .product_recommendations_slider", {
      spaceBetween: 20,
    	direction: "horizontal",
    	loop: true,
    	autoHeight: true,
    	navigation: {
    		nextEl: ".swiper-button-next",
    		prevEl: ".swiper-button-prev"
    	},
        breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 10
        },
        480: {
          slidesPerView: 2,
          spaceBetween: 20
        },
        640: {
          slidesPerView: 2,
          spaceBetween: 20
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1367: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      }
    });
     //console.log(recommendations_swiper)
   }
  window.addEventListener("load", function() {
    setTimeout(recommendations_loaded, 500);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  let toggles = document.getElementsByClassName("toggle");
  let contentDiv = document.getElementsByClassName("content");
  let icons = document.getElementsByClassName("icon");

  for (let i = 0; i < toggles.length; i++) {
      toggles[i].addEventListener("click", () => {
          if (parseInt(contentDiv[i].style.height) != contentDiv[i].scrollHeight) {
              contentDiv[i].style.height = contentDiv[i].scrollHeight + "px";
              toggles[i].style.color = "#0084e9";
              icons[i].classList.remove("fa-plus");
              icons[i].classList.add("fa-minus");
          } else {
              contentDiv[i].style.height = "0px";
              toggles[i].style.color = "#111130";
              icons[i].classList.remove("fa-minus");
              icons[i].classList.add("fa-plus");
          }

          for (let j = 0; j < contentDiv.length; j++) {
              if (j !== i) {
                  contentDiv[j].style.height = 0;
                  toggles[j].style.color = "#111130";
                  icons[j].classList.remove("fa-minus");
                  icons[j].classList.add("fa-plus");
              }
          }
      });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  //console.log(items)
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
  
  });
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);


                                   

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-carousel-slider"] && !Shopify.designMode) return;
  try {
    
  const imageCarouselSlider = new Swiper(".imageCarouselSlider", {
    slidesPerView: 4,
    spaceBetween: 20,
	direction: "horizontal",
	loop: true,
	autoHeight: true,
	pagination: {
		el: ".swiper-pagination"
	},
	navigation: {
		nextEl: ".swiper-button-next",
		prevEl: ".swiper-button-prev"
	},
    breakpoints: {
    320: {
      slidesPerView: 1,
      spaceBetween: 10
    },
    480: {
      slidesPerView: 2,
      spaceBetween: 20
    },
    640: {
      slidesPerView: 2,
      spaceBetween: 20
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    1367: {
      slidesPerView: 3,
      spaceBetween: 20,
    },      
  }
}); 
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meet_stephie"] && !Shopify.designMode) return;
  try {
    
   /* var swiper = new Swiper(".meet_slider_thum", {
    spaceBetween: 10,
    slidesPerView: 3,
    freeMode: true,
    watchSlidesProgress: true,
    breakpoints: {
    320: {
      slidesPerView: 1,
      spaceBetween: 10
    },
    480: {
      slidesPerView: 2,
      spaceBetween: 20
    },
    640: {
      slidesPerView: 3,
      spaceBetween: 20
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 20,
    }
  }
  });
  var swiper2 = new Swiper(".meet_slider", {
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: swiper,
    },
  });*/

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meet_team"] && !Shopify.designMode) return;
  try {
    
  var modal = document.querySelector(".modal");
  var trigger = document.querySelectorAll(".team-info .trigger");
  var closeButton = document.querySelector(".close-button");
  
  function toggleModal() {
    modal.classList.toggle("show-modal");
  }
  
  function windowOnClick(event) {
    if (event.target === modal) {
      toggleModal();
    }
  }
  
  trigger.forEach((item, index) => {
    item.addEventListener('click', (event) => {
      var html = item.parentElement.parentElement;
      document.getElementById('teamoutersec').innerHTML = html.outerHTML;
      console.log(html);
      toggleModal();
    });
  });
  
  closeButton.addEventListener("click", toggleModal);
  window.addEventListener("click", windowOnClick);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-latest-collection"] && !Shopify.designMode) return;
  try {
    
   const swiper = new Swiper(".ourLatestCollection_slider", {
      slidesPerView: 2,
      spaceBetween: 20,
  	direction: "horizontal",
  	loop: true,
  	autoHeight: true,
  	/*pagination: {
  		el: ".swiper-pagination"
  	},*/
  	navigation: {
  		nextEl: ".swiper-button-next",
  		prevEl: ".swiper-button-prev"
  	},
      breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 10
      },
      480: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      1024: {
        slidesPerView: 5,
        spaceBetween: 20,
      },
      1367: {
        slidesPerView: 5,
        spaceBetween: 20,
      },
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-partners"] && !Shopify.designMode) return;
  try {
    
  var partnersSwiper = new Swiper('.partners-swiper', {
    loop: true,
    autoplay: { delay: 2500 },
    slidesPerView: 4,
    spaceBetween: 20,
    breakpoints: {
      320: { slidesPerView: 2, spaceBetween: 10 },
      768: { slidesPerView: 3, spaceBetween: 15 },
      1024: { slidesPerView: 5, spaceBetween: 20 }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our_collection_Slider"] && !Shopify.designMode) return;
  try {
    
   const swiper = new Swiper(".ourLatestCollection_slider", {
      slidesPerView: 2,
      spaceBetween: 20,
  	direction: "horizontal",
  	loop: true,
  	autoHeight: true,
  	/*pagination: {
  		el: ".swiper-pagination"
  	},*/
  	navigation: {
  		nextEl: ".swiper-button-next",
  		prevEl: ".swiper-button-prev"
  	},
      breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 10
      },
      480: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
      1367: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our_pricing_sections"] && !Shopify.designMode) return;
  try {
    
    var swiper = new Swiper(".pricing_slider_thum",  {
    spaceBetween: 40,
    slidesPerView: 5,
    centeredSlides: true,
    centeredSlidesBounds: true,
  touchRatio: .5,
  virtualTranslate: true,
    breakpoints: {
    320: {
      slidesPerView: 1,
      spaceBetween: 10
    },
    480: {
      slidesPerView: 1,
      spaceBetween: 10
    },
    640: {
      slidesPerView: 3,
      spaceBetween: 10
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 10,
    }
  }
  });

  var swiper2 = new Swiper(".pricing_slider", {
    spaceBetween: 40,
    /*navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },*/
    breakpoints: {
    320: {
      slidesPerView: 1,
      spaceBetween: 10
    },
    480: {
      slidesPerView: 1,
      spaceBetween: 20
    },
    640: {
      slidesPerView: 1,
      spaceBetween: 20
    },
    1024: {
      slidesPerView: 1,
      spaceBetween: 20,
    }
  },
    thumbs: {
      swiper: swiper,
    },
  });
  var pricing_slider_inner = new Swiper(".pricing_slider_inner", {
    spaceBetween: 40,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
    320: {
      slidesPerView: 1,
      spaceBetween: 10
    },
    480: {
      slidesPerView: 2,
      spaceBetween: 20
    },
    640: {
      slidesPerView: 2,
      spaceBetween: 20
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 20,
    }
  }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our_services"] && !Shopify.designMode) return;
  try {
    
    var swiper = new Swiper(".our_service_slider_thum",  {
    spaceBetween: 10,
    slidesPerView: 5,
    centeredSlides: true,
    centeredSlidesBounds: true,
  touchRatio: .5,
  virtualTranslate: true,
    breakpoints: {
    320: {
      slidesPerView: 1,
      spaceBetween: 10
    },
    480: {
      slidesPerView: 2,
      spaceBetween: 10
    },
    640: {
      slidesPerView: 3,
      spaceBetween: 10
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 10,
    }
  }
  });
  var swiper2 = new Swiper(".our_service_slider", {
    spaceBetween: 10,
    thumbs: {
      swiper: swiper,
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["services_list_with_slide"] && !Shopify.designMode) return;
  try {
    
    var swiper = new Swiper(".service_slider_thum", {
    spaceBetween: 40,
    slidesPerView: 5,
    centeredSlides: true,
    centeredSlidesBounds: true,
  touchRatio: .5,
  virtualTranslate: true,
    breakpoints: {
    320: {
      slidesPerView: 1,
      spaceBetween: 10
    },
    480: {
      slidesPerView: 2,
      spaceBetween: 20
    },
    640: {
      slidesPerView: 3,
      spaceBetween: 20
    },
    1024: {
      slidesPerView: 5,
      spaceBetween: 20,
    }
  }
  });
  var swiper2 = new Swiper(".service_slider", {
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: swiper,
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tab-system"] && !Shopify.designMode) return;
  try {
    
  const tabs = document.querySelectorAll('[data-tab-target]')
  const tabContents = document.querySelectorAll('[data-tab-content]')
  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const target = document.querySelector(tab.dataset.tabTarget)
      tabContents.forEach(tabContent => {
        tabContent.classList.remove('active')
      })
      tabs.forEach(tab => {
        tab.classList.remove('active')
      })
      tab.classList.add('active')
      target.classList.add('active')
    })
  })

  // Read More functionality for Tab 2
  document.addEventListener('DOMContentLoaded', function() {
    const readMoreBtn = document.getElementById('tab2-read-more-btn');
    const contentPreview = document.getElementById('tab2-content-preview');
    
    if (readMoreBtn && contentPreview) {
      // Always show the read more button for tab 2
      readMoreBtn.style.display = 'block';
      
      readMoreBtn.addEventListener('click', function() {
        if (contentPreview.classList.contains('expanded')) {
          contentPreview.classList.remove('expanded');
          readMoreBtn.textContent = 'Read More';
        } else {
          contentPreview.classList.add('expanded');
          readMoreBtn.textContent = 'Read Less';
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-slider"] && !Shopify.designMode) return;
  try {
    
    const swiper = new Swiper(".testimonialSlider", {
  	direction: "horizontal",
  	loop: true,
  	autoHeight: true,
  	pagination: {
  		el: ".swiper-pagination"
  	},
  	navigation: {
  		nextEl: ".swiper-button-next",
  		prevEl: ".swiper-button-prev"
  	}
  });

  } catch(e) { console.error(e); }
})();
})();
